import styled, { css } from 'styled-components'
import { PopupInterface } from 'common/types/entities/popup-interface'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'

type PopupScrollContentUiProps = Pick<
  PopupInterface,
  'padding' | 'mobilePadding'
>

export const PopupScrollContentUi = styled.div<PopupScrollContentUiProps>`
  overflow-y: auto;
  max-height: inherit;

  ${paddingsCss}

  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobilePaddingsCss}
    `}
`
